"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const winston_transport_1 = __importDefault(require("winston-transport"));
class RollbarTransport extends winston_transport_1.default {
    log(data, next) {
        setImmediate(() => {
            this.emit('logged', data);
        });
        const rollbar = window.Rollbar;
        if (rollbar && rollbar[data.level]) {
            rollbar[data.level](data.message, data);
        }
        next();
    }
}
exports.default = RollbarTransport;
//# sourceMappingURL=winston-rollbar.js.map